import { Box, Grid, Stack, Typography } from '@mui/material';
import InputBase from '@mui/material/InputBase';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { ShAlert } from 'shared/SharedStyles/ShFeedback';
import { ApiStates } from 'shared/constants';
import { fetchCandidateDetails, updateCandidateDetails, resetCandidateUpdateState } from 'store/slices/admin/candidate/candidate-details-slice';
import { EmpInfoInputBlock, EmpInfoLabelBlock, StyledStack, ThemedBtn } from "Modules/Core/Admin/EmployerProfile/EmployerDetails.styled";
export const CandidateDetails = ({ candidateId }) => {
    const dispatch = useDispatch();
    const candidateDetails = useSelector((state) => state.candidate.adminCandidateSlice);
    const updatingCandidate = useSelector((state) => state.candidate.adminCandidateSlice);
    const updateResponse = useSelector((state) => state.candidate.adminCandidateSlice);
    const [formData, setFormData] = useState({
        first_name: '',
        middle_name: '',
        last_name: '',
        active: false,
        created_at: '',
        assessment_complete: false
    });
    useEffect(() => {
        if (candidateId) {
            dispatch(fetchCandidateDetails({ candidateId }));
        }
    }, [candidateId, dispatch]);
    useEffect(() => {
        if (candidateDetails) {
            setFormData({
                first_name: candidateDetails.candidateDetails.first_name,
                middle_name: candidateDetails.candidateDetails.middle_name,
                last_name: candidateDetails.candidateDetails.last_name,
                active: candidateDetails.candidateDetails.active,
                created_at: candidateDetails.candidateDetails.created_at,
                assessment_complete: candidateDetails.candidateDetails.assessment_complete
            });
        }
    }, [candidateDetails]);
    const handleSave = () => {
        dispatch(updateCandidateDetails({ candidateId, formData }));
        dispatch(fetchCandidateDetails({ candidateId }));
    };
    const Alerts = () => {
        switch (updatingCandidate) {
            case ApiStates.pending:
                return (<ShAlert severity="info">Updating...</ShAlert>);
            case ApiStates.success:
                return (<ShAlert onClose={() => { dispatch(resetCandidateUpdateState()) }} severity="success">{updateResponse}</ShAlert>);
            case ApiStates.failed:
                return (<ShAlert onClose={() => { dispatch(resetCandidateUpdateState()) }} severity="error">Error occurred while updating!</ShAlert>);
            default:
                return (<></>);
        }
    };
    return (
        <StyledStack id="candidate-profile">
          <Typography variant="h6" gutterBottom>
            Candidate Details
          </Typography>
          <Stack spacing={2}>
            <Grid container>
              <EmpInfoLabelBlock item xs={4}>
                <Typography variant="subtitle2">First Name</Typography>
              </EmpInfoLabelBlock>
              <EmpInfoInputBlock item xs={8}>
                <InputBase
                  name="first_name"
                  value={formData.first_name}
                  onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
                  placeholder="First Name"
                />
              </EmpInfoInputBlock>
            </Grid>
            <Grid container>
              <EmpInfoLabelBlock item xs={4}>
                <Typography variant="subtitle2">Middle Name</Typography>
              </EmpInfoLabelBlock>
              <EmpInfoInputBlock item xs={8}>
                <InputBase
                  name="middle_name"
                  value={formData.middle_name}
                  onChange={(e) => setFormData({ ...formData, middle_name: e.target.value })}
                  placeholder="Middle Name"
                />
              </EmpInfoInputBlock>
            </Grid>
            <Grid container>
              <EmpInfoLabelBlock item xs={4}>
                <Typography variant="subtitle2">Last Name</Typography>
              </EmpInfoLabelBlock>
              <EmpInfoInputBlock item xs={8}>
                <InputBase
                  name="last_name"
                  value={formData.last_name}
                  onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
                  placeholder="Last Name"
                />
              </EmpInfoInputBlock>
            </Grid>
            <Grid container>
              <EmpInfoLabelBlock item xs={4}>
                <Typography variant="subtitle2">Active</Typography>
              </EmpInfoLabelBlock>
              <EmpInfoInputBlock item xs={8}>
                <InputBase
                  name="active"
                  value={formData.active}
                  disabled= {true}
                  placeholder="Active"
                />
              </EmpInfoInputBlock>
            </Grid>
            <Grid container>
              <EmpInfoLabelBlock item xs={4}>
                <Typography variant="subtitle2">Created On</Typography>
              </EmpInfoLabelBlock>
              <EmpInfoInputBlock item xs={8}>
                <InputBase
                  name="created_at"
                  value={formData.created_at}
                  disabled= {true}
                  placeholder="Created "
                />
              </EmpInfoInputBlock>
            </Grid>
            <Grid container>
              <EmpInfoLabelBlock item xs={4}>
                <Typography variant="subtitle2">Assessment completed</Typography>
              </EmpInfoLabelBlock>
              <EmpInfoInputBlock item xs={8}>
                <InputBase
                  name="assessment_complete"
                  value={formData.assessment_complete}
                  disabled= {true}
                  placeholder="Assessment completed"
                />
              </EmpInfoInputBlock>
            </Grid>
          </Stack>
          <Box mt={2}>
            <ThemedBtn variant="contained" onClick={handleSave} disabled={updatingCandidate === ApiStates.pending}>
              Save Changes
            </ThemedBtn>
          </Box>
          {Alerts()}
        </StyledStack>
      );
};